import { maStateData } from '@components/seo/ma/data/maStateData';
import { NextSeo } from 'next-seo';
import BestMaIndex from '../../components/seo/ma/BestMaIndex';

const MaIndex = ({ maStateData }) => {
  const title = `Top-Rated Medicare Advantage Plans`;
  const description = `The top-rated Medicare Advantage plans for 2025.`;

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          type: 'website',
          locale: 'en-US',
          title,
          description,
          url: 'https://www.fairsquaremedicare.com/top-rated-medicare-advantage/',
          site_name: 'Fair Square Medicare',
        }}
      />
      <BestMaIndex maStateData={maStateData} />
    </>
  );
};

export async function getServerSideProps() {
  return {
    props: {
      maStateData,
    },
  };
}

export default MaIndex;
